import { Injectable, ViewChild } from '@angular/core';
import { BreadcrumbService, CoreService, FilesManagerService, HttpService } from '../../services';
import { CustomGridService } from '../customgrid.service';
import { BObjectModel, ParameterBoModel, CustomgridModel, CustomgridParam, GridParamGeneric, FileModel, eAppContext, EventsModel, ParamApplication, BreadcrumbModel, QueovalParam, BreadDik } from '../../models';
import { ToastService } from '../../toast';
import * as fileSaver from 'file-saver';


@Injectable({
  providedIn: 'root'
})

export class CustomGridItemService {

  constructor(
    protected httpService: HttpService,
    protected toastService: ToastService,
    private indParam: CoreService,
  ) { }

  public DecimalRenderer(params: any): string {
    if (params?.data?.isFooter || params.node.isRowPinned()) { return params.value; }
    return params.value || params.value == 0 ? Number(params.value).toFixed(2).toString() : '';
  }
  public NumberRenderer(params: any): string {
    if (params?.data?.isFooter || params.node.isRowPinned()) { return params.value; }
    return params.value || params.value == 0 ? Number(params.value).toFixed() : '';
  }
  public MonetaryRenderer(params: any, indParam: CoreService): string {
    if (params?.data?.isFooter || params.node.isRowPinned()) { return params.value; }
    return params.value || params.value == 0 ? Number(params.value).toFixed(2) : '';


    let value = Number(`${params.value}`.replace(',', '.')) ? Number(`${params.value}`.replace(',', '.')) : 0;

    let devise: string;
    switch (indParam.AppParams.Devise) {
      case '€': devise = 'EUR'; break;
      case '$': devise = 'USD'; break;
      case '£': devise = 'GBP'; break;
      default: devise = this.indParam.AppParams.Devise; break;
    }

    return new Intl.NumberFormat(indParam.AppParams.culture, { style: 'currency', currency: devise }).format(value);
  }
  public DecimalComparator(decimal1: string, decimal2: string): number {

    const date1Number: number | null = !decimal1 ? null : Math.round(parseFloat(decimal1) * 100) / 100;
    const date2Number: number | null = !decimal2 ? null : Math.round(parseFloat(decimal2) * 100) / 100;

    if (!date1Number && !date2Number) {
      return 0;
    }
    if (!date1Number) {
      return -1;
    }
    if (!date2Number) {
      return 1;
    }
    return date1Number - date2Number;
  }

  public StringComparator(value1: any, value2: any): number {
    if (!value1 && !value2) {
      return 0;
    }
    if (!value1) {
      return -1;
    }
    if (!value2) {
      return 1;
    }
    if (value1.toString().toLowerCase() > value2.toString().toLowerCase()) {
      return 1;
    }
    if (value1.toString().toLowerCase() < value2.toString().toLowerCase()) {
      return -1;
    }
    if (value1.toString().toLowerCase() === value2.toString().toLowerCase()) {
      return 0;
    }
    return 0;
  }
  public dateComparator(date1: string, date2: string): number {

    function monthToComparableNumber(date: string): null | number {
      if (!date || date.length < 10) {
        return null;
      }
      const yearNumber: number = parseInt(date.substring(6, 10));
      const monthNumber: number = parseInt(date.substring(3, 5));
      const dayNumber: number = parseInt(date.substring(0, 2));
      return yearNumber * 10000 + monthNumber * 100 + dayNumber;
    }

    const date1Number: number | null = monthToComparableNumber(date1);
    const date2Number: number | null = monthToComparableNumber(date2);
    if (date1Number === null && date2Number === null) {
      return 0;
    }
    if (date1Number === null) {
      return -1;
    }
    if (date2Number === null) {
      return 1;
    }
    return date1Number - date2Number;
  }

  public dateFormatter(field: string, type: string, culture: string): any {
    switch (type) {
      case 'dateshort':
        return function (params: any) {
          var dateAsString = params.data ? params.data[field] : '';
          var dateParts = dateAsString ? dateAsString.split('/') : [];
          if (dateParts.length > 2) {
            const date: Date = new Date(Number.parseInt(dateParts[2]), Number.parseInt(dateParts[1]) - 1, Number.parseInt(dateParts[0]));
            const options: Intl.DateTimeFormatOptions = { month: 'short' };
            return `${dateParts[0]} ${new Intl.DateTimeFormat(culture, options).format(date)} ${dateParts[2]}`;
          } else { return dateAsString }
        }
      case 'datelong':
        return function (params: any) {
          var dateAsString = params.data ? params.data[field] : '';
          var dateParts = dateAsString ? dateAsString.split('/') : [];
          if (dateParts.length > 2) {
            const date: Date = new Date(Number.parseInt(dateParts[2]), Number.parseInt(dateParts[1]) - 1, Number.parseInt(dateParts[0]));
            const options: Intl.DateTimeFormatOptions = { month: 'long' };
            return `${dateParts[0]} ${new Intl.DateTimeFormat(culture, options).format(date)} ${dateParts[2]}`;
          } else { return dateAsString }
        }
      case 'datetime':
        return function (params: any) {
          var dateAsString = params.data ? params.data[field] : '';
          return dateAsString;
        }
      case 'date':
      default:
        return function (params: any) {
          var dateAsString = params.data ? params.data[field] : '';
          var dateParts = dateAsString ? dateAsString.split('/') : [];
          if (dateParts.length > 2) {
            return `${dateParts[0]}/${dateParts[1]}/${dateParts[2]}`;
          } else { return dateAsString }
        }
    }
  }
  public filterParams(): any {
    return {
      debounceMs: 500,
      //suppressAndOrCondition: true,
      comparator: function (filterLocalDateAtMidnight: Date, cellValue: string | null) {
        if (cellValue == null) return -1;
        var dateParts = cellValue.split('/');
        var cellDate = new Date(
          Number(dateParts[2].substring(0, 4)),
          Number(dateParts[1]) - 1,
          Number(dateParts[0])
        );
        if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
          return 0;
        }
        if (cellDate < filterLocalDateAtMidnight) {
          return -1;
        }
        if (cellDate > filterLocalDateAtMidnight) {
          return 1;
        }
      }
    }
  }

  public ComboRenderer(params: any): string {
    if (params?.data?.isFooter || params.node.isRowPinned()) return '';
    return (params.column.userProvidedColDef.cellEditorParams.param as Array<{ id: string, value: string }>).find(x => x.id == params.value)?.value ?? `*${params.value}`;
  }


  //#region filtres columnDefs
  public ItemsRenderer(indParam: CoreService, service: CustomGridService, fileService: FilesManagerService, pHttpService: HttpService, breadcrumbService: BreadcrumbService, index: any = 0, key: string, identUnique: number): any {

    return (params: any): any => {
      if (!params.value) {
        return;
      }

      // Recuperation de la valeur TYPE_COMPOSANT|PARAMETRE|DISPLAY|OPTION|
      const paramArray: Array<string> = params.value.split(`|`);
      const type: string = paramArray[0];
      const parameter: string = paramArray[1];
      let display: string = '';
      let option: string = '';
      let value: string = '';
      let idBo: string = '';
      //////let idDonnee: string = '';
      let idRelation: string = '';
      let idDonneePere: string = '';
      let idBOPere: string = '';
      // condition d'affichage sur certains boutons
      let isShow: string = '';

      const eDiv: HTMLDivElement = document.createElement('div');
      let eButton: any = null;

      switch (type) {
        //#region Boutons/BoBoutons
        case 'BUTTON':
        case 'BOBUTTON':
          //#region affectation valeurs des variables
          display = paramArray[2];
          option = paramArray[3];
          value = paramArray[4];
          idBo = paramArray[5];
          idRelation = paramArray[6];
          idDonneePere = paramArray[7];
          idBOPere = paramArray[8];
          isShow = paramArray[9];

          //#endregion
          switch (parameter) {

            //#region MULTIPLEACTIONSTAGEDOCUMENT
            case 'MULTIPLE_ACTION_STAGE_DOCUMENT':
              let docName: string = option;
              let extension: string = docName.split('.')[1];

              eDiv.innerHTML += `<i id="OPENBO${index}" class="fas fa-edit q-c-main q-pointer m-2" placement="right" title="Modifier le document"></i>`;
              eDiv.innerHTML += `<i id="REPLACEDOC${index}" class="fas fa-upload q-c-main q-pointer m-2" placement="right" title="Remplacer le document"></i>`;
              eDiv.innerHTML += `<i id="DONWLOAD${index}" class="fas fa-file-download q-c-main q-pointer m-2" placement="right" title="Télécharger le document"></i>`;

              // Ajout du bouton dans le cas d'un docx pour télécharger le format pdf (et creer le pdf s'il n'existe pas déjà)
              if (docName.endsWith('.docx') || docName.endsWith('.doc')) {
                eDiv.innerHTML += `<i id="DONWLOADPDF${index}" class="fas fa-file-pdf q-c-main q-pointer m-2" placement="right" title="Télécharger le PDF"></i>`;

                let eButtonDONWLOADPDF = eDiv.querySelectorAll(`#DONWLOADPDF${index}`)[0];
                eButtonDONWLOADPDF.addEventListener('click', ($event: Event): void => {
                  const fileModel: FileModel = new FileModel();
                  fileModel.DownloadMode = 'DOCXGENERE';
                  fileModel.Ident = value;
                  fileModel.Extension = 'pdf';
                  fileModel.Name = value;
                  fileModel.DisplayName = display;
                  fileService.downloadFile(fileModel);
                });
              }

              // Bouton pour ouvrir le bo document
              let eButtonOPENBO = eDiv.querySelectorAll(`#OPENBO${index}`)[0];
              eButtonOPENBO.addEventListener('click', function (): void {
                const modelModale: any = {
                  Action: "OPENBO",
                  Value: value,
                  Bo: idBo,
                  Relation: idRelation,
                };
                service.sendItem(key, modelModale);
              });

              // bouton pour télécharger le document peu importe l'extention 
              let eButtonDONWLOAD = eDiv.querySelectorAll(`#DONWLOAD${index}`)[0];
              eButtonDONWLOAD.addEventListener('click', ($event: Event): void => {
                const fileModel: FileModel = new FileModel();
                fileModel.DownloadMode = 'DOCXGENERE';
                fileModel.Ident = value;
                fileModel.Extension = extension;
                fileModel.Name = value;
                fileModel.DisplayName = display;
                fileService.downloadFile(fileModel);
                //  this.DonwloadFileFromCustomgrid($event, value, false);
              });

              // Bouton pour remplacer le document
              let eButtonREPLACEDOC = eDiv.querySelectorAll(`#REPLACEDOC${index}`)[0];
              eButtonREPLACEDOC.addEventListener('click', function (): void {
                const modelModale: any = {
                  Action: "REPLACEDOC",
                  Value: value,
                };
                service.sendItem(key, modelModale);
              });


              break;
            //#rendegion MULTIPLEACTIONSTAGEDOCUMENT

            //#region ASPX_EMAIL_ACTION
            case 'ASPX_EMAIL_ACTION':
              //#region HTML
              if (!display || display === '') {
                eDiv.innerHTML = `<i id="ASPX_EMAIL_ACTION${index}" class="far fa-paper-plane q-c-main q-pointer" placement="right" > </i>`;
              } else {
                eDiv.innerHTML = `<i id="ASPX_EMAIL_ACTION${index}" class="far fa-paper-plane q-c-main q-pointer" placement="right title="${display}" > </i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll(`#ASPX_EMAIL_ACTION${index}`)[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                //open(`${indParam.ConfigFile.appUrl}PageEmailAction.aspx?CA=${value}&GROUPE=${option}`);
                open(`${indParam.AppParams.appUrl}PageEmailAction.aspx?CA=${value}&GROUPE=${option}&BO=${idDonneePere}`);
              });
              //#endregion
              break;
            //#endregion

            //#region ASPX_PAGE
            case 'ASPX_PAGE':
              //#region HTML
              if (!display || display === '') {
                eDiv.innerHTML = `<i id="ASPX_PAGE" class="fas fa-edit q-c-main q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ASPX_PAGE" class="fas fa-edit q-c-main q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll('#ASPX_PAGE')[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                //open(`${indParam.ConfigFile.appUrl}pagedonnee.aspx?P1=${option}&P2=${value}`);
                open(`${indParam.AppParams.appUrl}pagedonnee.aspx?P1=${option}&P2=${value}`);
              });
              //#endregion
              break;
            //#endregion

            case 'ANG_SEGMENTATION':
              //#region HTML
              if (!display || display === '') {
                eDiv.innerHTML = `<i id="ANG_SEGMENTATION" class="fas fa-edit q-c-main q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ANG_SEGMENTATION" class="fas fa-edit q-c-main q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll('#ANG_SEGMENTATION')[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {

                const paramBoModelSegmentation: ParameterBoModel = new ParameterBoModel();
                paramBoModelSegmentation.P1 = `${indParam.AppParams.appUrl}pagedonnee.aspx`;
                paramBoModelSegmentation.P2 = `P1=${option}&P2=${value}`;
                paramBoModelSegmentation.P3 = `${indParam.AppParams.appUrl}pagedonnee.aspx?P1=${option}&P2=${value}`;
                paramBoModelSegmentation.CodeBo = option;
                paramBoModelSegmentation.IdDonnee = value;
                paramBoModelSegmentation.FILE = `${indParam.AppParams.appUrl}pagedonnee.aspx`;
                paramBoModelSegmentation.Action = `ANG_SEGMENTATION`;
                service.sendItem(key, paramBoModelSegmentation);

              });
              //#endregion

              break;

            case 'ANG_SEGMENTATION_BREADCRUMB':
              if (indParam.Context === eAppContext.QUEOVAL) {
                //#region HTML
                if (!display || display === '') {
                  eDiv.innerHTML = `<i id="ANG_SEGMENTATION" class="fas fa-external-link-alt q-c-main q-pointer" placement="right"></i>`;
                } else {
                  eDiv.innerHTML = `<i id="ANG_SEGMENTATION" class="fas fa-external-link-alt q-c-main q-pointer" placement="right" title="${display}"></i>`;
                }
                //#endregion
                eButton = eDiv.querySelectorAll('#ANG_SEGMENTATION')[0];
                //#region Ts
                eButton.addEventListener('click', function (): void {

                  const paramBoModelSegmentation: ParameterBoModel = new ParameterBoModel();
                  paramBoModelSegmentation.P1 = `view/segmentation`;
                  paramBoModelSegmentation.P2 = `P1=${option}&P2=${value}'`;
                  paramBoModelSegmentation.CodeBo = option;
                  paramBoModelSegmentation.IdDonnee = value;
                  paramBoModelSegmentation.Action = `ANG_SEGMENTATION_BREADCRUMB`;
                  service.sendItem(key, paramBoModelSegmentation);

                });
                //#endregion
              }
              break;
            case 'ANG_SEGMENTATION_GRID':
              if (indParam.Context === eAppContext.QUEOVAL) {
                //#region HTML
                if (!display || display === '') {
                  eDiv.innerHTML = `<i id="ANG_SEGMENTATION" class="fas fa-external-link-alt q-c-main q-pointer" placement="right"></i>`;
                } else {
                  eDiv.innerHTML = `<i id="ANG_SEGMENTATION" class="fas fa-external-link-alt q-c-main q-pointer" placement="right" title="${display}"></i>`;
                }
                //#endregion
                eButton = eDiv.querySelectorAll('#ANG_SEGMENTATION')[0];
                //#region Ts
                eButton.addEventListener('click', function (): void {

                  const paramBoModelSegmentation: ParameterBoModel = new ParameterBoModel();
                  paramBoModelSegmentation.P1 = option;
                  paramBoModelSegmentation.P2 = value;
                  paramBoModelSegmentation.FILE = option;
                  paramBoModelSegmentation.Action = `ANG_SEGMENTATION_GRID`;
                  service.sendItem(key, paramBoModelSegmentation);

                });
                //#endregion
              }
              break;

            //#region ASPX_EXPORT_GEN
            case 'ASPX_EXPORT_GEN':
              //#region HTML
              if (!display || display === '') {
                eDiv.innerHTML = `<i id="ASPX_EXPORT_GEN" class="fas fa-file-upload q-c-main q-pointer" placement="right"> </i>`;
              } else {
                eDiv.innerHTML = `<i id="ASPX_EXPORT_GEN" class="fas fa-file-upload q-c-main q-pointer" placement="right" title="${display}"> </i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll('#ASPX_EXPORT_GEN')[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                //open(`${indParam.ConfigFile.appUrl}PageExportGeneric.aspx?IDENT=${value}&P5=DOCXTOPDF`);
                open(`${indParam.AppParams.appUrl}PageExportGeneric.aspx?IDENT=${value}&P5=DOCXTOPDF`);
              });
              //#endregion
              break;
            //#endregion

            //#region ASPX_CVT
            case 'ASPX_CVT':
              //#region HTML
              if (!display || display === '') {
                eDiv.innerHTML = `<i id="ASPX_CVT${index}" class="fas fa-edit q-c-main q-pointer" placement="right" > </i>`;
              } else {
                eDiv.innerHTML = `<i id="ASPX_CVT${index}" class="fas fa-edit q-c-main q-pointer" placement="right title="${display}" > </i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll(`#ASPX_CVT${index}`)[0];
              //#region Ts
              indParam.GetParamsApplication([new ParamApplication('FORMATION_MODE', 'PARAM')]).subscribe((param: ParamApplication[]) => {
                if (param[0].StrValue.toUpperCase() == 'NEW') {
                  eButton.addEventListener('click', function (): void {
                    const data: QueovalParam = new QueovalParam(new BreadDik('idConvention', value));
                    data.params.push(new BreadDik('filterClient', true));
                    const Breadcrumb = new BreadcrumbModel('add', `view/formations/stage-detail/${option}/convention`, data, 'Convention du stage', true);
                    breadcrumbService.call(Breadcrumb);
                  });
                } else {
                  eButton.addEventListener('click', function (): void {
                    //open(`${indParam.ConfigFile.appUrl}/Formation/PageCreateConvention.aspx?CVT=${value}&CA=${option}`);
                    open(`${indParam.AppParams.appUrl}/Formation/PageCreateConvention.aspx?CVT=${value}&CA=${option}`);
                  });
                }
              });
              //#endregion
              break;
            //#endregion

            //#region ANG_PAGE
            case 'ANG_PAGE':

              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ANG_PAGE${index}" class="fas fa-edit q-c-main q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ANG_PAGE${index}" class="fas fa-edit q-c-main q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll(`#ANG_PAGE${index}`)[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                const modelPage: BObjectModel = new BObjectModel();
                const optionArray: Array<string> = option.split(',');
                modelPage.ShowSaveButton = optionArray.length > 0 && optionArray[0] === 'S1' ? true : false;
                modelPage.ShowRemoveButton = optionArray.length > 1 && optionArray[1] === 'D1' ? true : false;
                modelPage.ShowCreateButton = optionArray.length > 2 && optionArray[2] === 'C1' ? true : false;
                modelPage.IdDonneeFils = value;
                modelPage.IdDonneePere = idDonneePere;
                modelPage.IdentBO = idBo;
                modelPage.IdRelation = idRelation;
                modelPage.Mode = 'CREATE';
                modelPage.Action = `ANG_PAGE`;
                modelPage.Title = display;
                service.sendItem(key, modelPage);
              });
              //#endregion
              break;
            //#endregion

            //#region ASPX_LIEU_STAGE
            case 'ASPX_LIEU_STAGE':
              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ASPX_LIEU_STAGE" class="fas fa-map-marker q-c-main q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ASPX_LIEU_STAGE" class="fas fa-map-marker q-c-main q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll('#ASPX_LIEU_STAGE')[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                //open(`${indParam.ConfigFile.appUrl}SPEF_STAGE/PageLieuStage.aspx?P1=${value}`);
                open(`${indParam.AppParams.appUrl}SPEF_STAGE/PageLieuStage.aspx?P1=${value}`);
              });
              //#endregion
              break;
            //#endregion

            //#region ASPX_SUIVI_PRESENCE
            case 'ASPX_SUIVI_PRESENCE':
              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ASPX_SUIVI_PRESENCE" class="far fa-list-alt q-c-main q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ASPX_SUIVI_PRESENCE" class="far fa-list-alt q-c-main q-pointer" placement="right"  title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll('#ASPX_SUIVI_PRESENCE')[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                //open(`${indParam.ConfigFile.appUrl}SPEF_STAGE/PageSuiviPresence.aspx?IDDONNEE=${value}`);
                open(`${indParam.AppParams.appUrl}SPEF_STAGE/PageSuiviPresence.aspx?IDDONNEE=${value}`);
              });
              //#endregion
              break;
            //#endregion

            //#region ASPX_CREER_RESERVATION
            case 'ASPX_CREER_RESERVATION':
              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ASPX_CREER_RESERVATION" class="far fa-calendar-plus q-c-main q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ASPX_CREER_RESERVATION" class="far fa-calendar-plus q-c-main q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll('#ASPX_CREER_RESERVATION')[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                //open(`${indParam.ConfigFile.appUrl}SPEF_STAGE/PageCreateReservation.aspx?EnvoiMailICS=${option}&CA=${value}`);
                open(`${indParam.AppParams.appUrl}SPEF_STAGE/PageCreateReservation.aspx?EnvoiMailICS=${option}&CA=${value}`);
              });
              //#endregion
              break;
            //#endregion

            //#region ASPX_SUIVI_DOC
            case 'ASPX_SUIVI_DOC':
              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ASPX_SUIVI_DOC" class="far fa-file-alt q-c-main q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ASPX_SUIVI_DOC" class="far fa-file-alt q-c-main q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll('#ASPX_SUIVI_DOC')[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                //open(`${indParam.ConfigFile.appUrl}SPEF_DOC/PageSuiviDoc.aspx?P1=3&P2=${value}`);
                open(`${indParam.AppParams.appUrl}SPEF_DOC/PageSuiviDoc.aspx?P1=3&P2=${value}`);
              });
              //#endregion
              break;
            //#endregion

            //#region ASPX_INSERT_DOC
            case 'ASPX_INSERT_DOC':
              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ASPX_INSERT_DOC" class="fas fa-edit q-c-main q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ASPX_INSERT_DOC" class="fas fa-edit q-c-main q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll('#ASPX_INSERT_DOC')[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                //open(`${indParam.ConfigFile.appUrl}SPEF_DOC/PageInsertDocument.aspx?IdBO=${option}&IdDonnee=${value}`);
                open(`${indParam.AppParams.appUrl}SPEF_DOC/PageInsertDocument.aspx?IdBO=${option}&IdDonnee=${value}`);
              });
              //#endregion
              break;
            //#endregion

            //#region ASPX_VISU_RESERV
            case 'ASPX_VISU_RESERV':
              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ASPX_VISU_RESERV" class="far fa-calendar-alt q-c-main q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ASPX_VISU_RESERV" class="far fa-calendar-alt q-c-main q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll('#ASPX_VISU_RESERV')[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                //open(`${indParam.ConfigFile.appUrl}SPEF_AGENDA/PageVisuReservation.aspx?IdUser=${indParam.AppParams.LoggedUser.Ident}&Date=&IdDonnee=${value}&IdRelation=${option}&NoModif=True&AllDay=0`);
                open(`${indParam.AppParams.appUrl}SPEF_AGENDA/PageVisuReservation.aspx?IdUser=${indParam.AppParams.LoggedUser.Ident}&Date=&IdDonnee=${value}&IdRelation=${option}&NoModif=True&AllDay=0`);
              });
              //#endregion
              break;
            //#endregion

            //#region ANG_LIEU_STAGE
            case 'ANG_LIEU_STAGE':
              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ANG_LIEU_STAGE${index}" class="fas fa-map-marker q-c-main q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ANG_LIEU_STAGE${index}" class="fas fa-map-marker q-c-main q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll(`#ANG_LIEU_STAGE${index}`)[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                const paramBoModelLieuStage: ParameterBoModel = new ParameterBoModel();
                paramBoModelLieuStage.P1 = value;
                paramBoModelLieuStage.Action = `ANG_LIEU_STAGE`;
                service.sendItem(key, paramBoModelLieuStage);
              });
              //#endregion
              break;
            //#endregion

            //#region ANG_REGIST_STAGIAIRE
            case 'ANG_REGIST_STAGIAIRE':
              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ANG_REGIST_STAGIAIRE${index}" class="fas fa-user-graduate q-c-main q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ANG_REGIST_STAGIAIRE${index}" class="fas fa-user-graduate q-c-main q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll(`#ANG_REGIST_STAGIAIRE${index}`)[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                const paramBoModelRegistStagiaire: any =
                {
                  strIdStage: paramArray[4],
                  strIdClient: paramArray[7],
                  bolInscription: '',
                  bolBloqueInscription: paramArray[8],
                  Action: `ANG_REGIST_STAGIAIRE`
                };
                service.sendItem(key, paramBoModelRegistStagiaire);
              });
              //#endregion
              break;
            //#endregion

            //#region ANG_REGIST_STAGIAIRE
            case 'ANG_RESA_FORMATEUR':
              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ANG_RESA_FORMATEUR${index}" class="fas fa-calendar-plus q-c-main q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ANG_RESA_FORMATEUR${index}" class="fas fa-calendar-plus q-c-main q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll(`#ANG_RESA_FORMATEUR${index}`)[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                const paramResaFormateur: any =
                {
                  strIdStage: paramArray[4],
                  Action: `ANG_RESA_FORMATEUR`
                };
                service.sendItem(key, paramResaFormateur);
              });
              //#endregion
              break;
            //#endregion

            //#region ANG_SUIVI_PRESENCE
            case 'ANG_SUIVI_PRESENCE':
              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ANG_SUIVI_PRESENCE${index}" class="far fa-list-alt q-c-main q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ANG_SUIVI_PRESENCE${index}" class="far fa-list-alt q-c-main q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll(`#ANG_SUIVI_PRESENCE${index}`)[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                //!!!!!! Actualy not used TO DO

                //const paramBoModelLieuStage: ParameterBoModel = new ParameterBoModel();
                //paramBoModelLieuStage.P1 = idBo;
                //paramBoModelLieuStage.P2 = value;
                //paramBoModelLieuStage.Action = `ANG_SUIVI_PRESENCE`;
                //service.sendItem(key,paramBoModelLieuStage);
              });
              //#endregion
              break;
            //#endregion

            //#region ANG_CREER_RESERVATION
            case 'ANG_CREER_RESERVATION':
              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ANG_CREER_RESERVATION${index}" class="far fa-calendar-plus q-c-main q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ANG_CREER_RESERVATION${index}" class="far fa-calendar-plus q-c-main q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll(`#ANG_CREER_RESERVATION${index}`)[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                //!!!!!! Actualy not used TO DO

                //const paramBoModelLieuStage: ParameterBoModel = new ParameterBoModel();
                //paramBoModelLieuStage.P1 = idBo;
                //paramBoModelLieuStage.P2 = value;
                //paramBoModelLieuStage.Action = `ANG_CREER_RESERVATION`;
                //service.sendItem(key,paramBoModelLieuStage);
              });
              //#endregion
              break;
            //#endregion

            //#region ANG_SUIVI_DOC
            case 'ANG_SUIVI_DOC':
              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ANG_SUIVI_DOC${index}" class="far fa-file-alt color-icon q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ANG_SUIVI_DOC${index}" class="far fa-file-alt color-icon q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll(`#ANG_SUIVI_DOC${index}`)[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                //!!!!!! Actualy not used TO DO

                //const paramBoModelLieuStage: ParameterBoModel = new ParameterBoModel();
                //paramBoModelLieuStage.P1 = idBo;
                //paramBoModelLieuStage.P2 = value;
                //paramBoModelLieuStage.Action = `ANG_SUIVI_DOC`;
                //service.sendItem(key,paramBoModelLieuStage);
              });
              //#endregion
              break;
            //#endregion

            //#region ANG_INSERT_DOC
            case 'ANG_INSERT_DOC':
              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ANG_INSERT_DOC${index}" class="fas fa-edit color-icon q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ANG_INSERT_DOC${index}" class="fas fa-edit color-icon q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll(`#ANG_INSERT_DOC${index}`)[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                const modelInsertDoc: BObjectModel = new BObjectModel();
                modelInsertDoc.IdDonneeFils = '0';
                modelInsertDoc.IdDonneePere = value;
                modelInsertDoc.IdentBO = idBo;
                modelInsertDoc.IdRelation = idRelation;
                modelInsertDoc.Mode = 'CREATE';
                modelInsertDoc.Action = 'ANG_INSERT_DOC';
                service.sendItem(key, modelInsertDoc);
              });
              //#endregion
              break;
            //#endregion

            //#region ANG_EXPORT_GEN
            case 'ANG_EXPORT_GEN':
              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ANG_EXPORT_GEN${index}" class="fas fa-file-upload color-icon q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ANG_EXPORT_GEN${index}" class="fas fa-file-upload color-icon q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll(`#ANG_EXPORT_GEN${index}`)[0];
              //#region Ts
              eButton.addEventListener('click', ($event: Event): void => {
                this.DonwloadFileFromCustomgrid($event, value);
              });

              //#endregion
              break;
            //#endregion

            //#region ANG_VISU_RESERV
            case 'ANG_VISU_RESERV':
              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ANG_VISU_RESERV${index}" class="far fa-calendar-alt color-icon q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ANG_VISU_RESERV${index}" class="far fa-calendar-alt color-icon q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll(`#ANG_VISU_RESERV${index}`)[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                //!!!!!! Actualy not used TO DO

                //const paramBoModelLieuStage: ParameterBoModel = new ParameterBoModel();
                //paramBoModelLieuStage.P1 = idBo;
                //paramBoModelLieuStage.P2 = value;
                //paramBoModelLieuStage.Action = `ANG_VISU_RESERV`;
                //service.sendItem(key,paramBoModelLieuStage);
              });
              //#endregion
              break;
            //#endregion

            //#region ANG_CUSTOMGRID
            case 'ANG_CUSTOMGRID':
              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ANG_CUSTOMGRID${index}" class="far fa-list-alt color-icon q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ANG_CUSTOMGRID${index}" class="far fa-list-alt color-icon q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll(`#ANG_CUSTOMGRID${index}`)[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                const cgModel: CustomgridModel = new CustomgridModel();
                cgModel.cgParameters = new CustomgridParam();
                // nomfichier|IsDashboard|inputIdDonnee|inputIdRelation|CompleteWhere|CompleteHaving|inputIdParent
                //cgModel.cgParameters.FileName = `${option}|0|${value}|${idRelation}|||${idDonneePere}`;
                cgModel.cgParameters.FileName = option;
                cgModel.cgParameters.IsDashboard = false;
                cgModel.cgParameters.IdDonnee = value;
                cgModel.cgParameters.IdBO = idBo;
                cgModel.cgParameters.IdRelation = idRelation;
                cgModel.cgParameters.IdDonneeParent = idDonneePere;
                cgModel.cgParameters.IdBOParent = idBOPere;
                cgModel.Action = 'ANG_CUSTOMGRID';
                service.sendItem(key, cgModel);
              });
              //#endregion
              break;
            //#endregion

            case 'ANG_CERTIF_STAGIAIRE':
              if (display === '') {
                eDiv.innerHTML = `<i id="ANG_CERTIF_STAGIAIRE${index}" class="far fa-list-alt color-icon q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ANG_CERTIF_STAGIAIRE${index}" class="far fa-list-alt color-icon q-pointer" placement="right" title="${display}"></i>`;
              }

              eButton = eDiv.querySelectorAll(`#ANG_CERTIF_STAGIAIRE${index}`)[0];

              eButton.addEventListener('click', (): void => {
                const cgModel: CustomgridModel = new CustomgridModel();
                cgModel.cgParameters = new CustomgridParam();
                cgModel.cgParameters.IdDonnee = value;
                cgModel.Action = 'ANG_CERTIF_STAGIAIRE';
                service.sendItem(key, cgModel);
              });
              break;

            //#region ANG_GESTION_CYCLE_EL
            case 'ANG_GESTION_CYCLE_EL':
              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ANG_GESTION_CYCLE_EL${index}" class="fas fa-table color-icon q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ANG_GESTION_CYCLE_EL${index}" class="fas fa-table color-icon q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll(`#ANG_GESTION_CYCLE_EL${index}`)[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                const modelGestionCycle: any = {
                  IdDonneeFils: value,
                  Action: parameter
                }
                service.sendItem(key, modelGestionCycle);
              });
              //#endregion
              break;
            //#endregion

            //#region ANG_STATS
            case 'ANG_STATS':
              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ANG_STATS${index}" class="fas fa-chart-bar color-icon q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ANG_STATS${index}" class="fas fa-chart-bar color-icon q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll(`#ANG_STATS${index}`)[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                const modelBoStats: BObjectModel = new BObjectModel();
                modelBoStats.IdDonneeFils = value;
                modelBoStats.Action = parameter;
                service.sendItem(key, modelBoStats);
              });
              //#endregion
              break;
            //#endregion

            //#region ANG_CUSTOMGRID
            case 'ANG_PAGE_ESIGNED':
              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ANG_PAGE_ESIGNED${index}" class="fas fa-edit color-icon q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ANG_PAGE_ESIGNED${index}" class="fas fa-edit color-icon q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll(`#ANG_PAGE_ESIGNED${index}`)[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                const modelPage: BObjectModel = new BObjectModel();
                modelPage.ShowSaveButton = false;
                modelPage.ShowRemoveButton = false;
                modelPage.ShowCreateButton = false;
                modelPage.IdDonneeFils = value;
                modelPage.IdDonneePere = '';
                modelPage.IdentBO = '';
                modelPage.IdRelation = '';
                modelPage.Mode = option;
                modelPage.Action = `ANG_PAGE_ESIGNED`;
                service.sendItem(key, modelPage);
              });
              //#endregion
              break;
            //#endregion

            //#region ANG_VISU_FAC
            case 'ANG_VISU_FAC':
              if (value !== '0') {
                //#region HTML
                if (display === '') {
                  eDiv.innerHTML = `<i id="ANG_VISU_FAC${index}" class="fas fa-map-marker color-icon q-pointer" placement="right"></i>`;
                } else {
                  eDiv.innerHTML = `<i id="ANG_VISU_FAC${index}" class="fas fa-map-marker color-icon q-pointer" placement="right" title="${display}"></i>`;
                }
                //#endregion
                eButton = eDiv.querySelectorAll(`#ANG_VISU_FAC${index}`)[0];
                //#region Ts
                eButton.addEventListener('click', function (): void {
                  const modelVisuFac: any = {
                    Action: parameter,
                    IdDonnee: value
                  };
                  service.sendItem(key, modelVisuFac);
                });
                //#endregion
              }
              break;
            //#endregion

            //#region ANG_DWLD_CUSTOM 
            case 'ANG_DWLD_CUSTOM':
              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ANG_DWLD_CUSTOM${index}" class="fas fa-money-bill color-icon q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ANG_DWLD_CUSTOM${index}" class="fas fa-money-bill color-icon q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll(`#ANG_DWLD_CUSTOM${index}`)[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                const modelDwldCustom: any = {
                  Action: parameter,
                  IdDonnee: value,
                  // Pour bloquer le "multi-téléchargement" simultané -> récupération du timestamp du clic
                  TimeClic: Date.now()
                };
                service.sendItem(key, modelDwldCustom);
              });
              //#endregion
              break;
            //#endregion

            //#region UPDATE_PREST
            case 'UPDATE_PREST':
              //#region HTML
              if (isShow === 'true') {
                if (display === '') {
                  eDiv.innerHTML = `<i id="UPDATE_PREST${index}" class="fas fa-money-bill color-icon q-pointer" placement="right"></i>`;
                } else {
                  eDiv.innerHTML = `<i id="UPDATE_PREST${index}" class="fas fa-money-bill color-icon q-pointer" placement="right" title="${display}"></i>`;
                }
                //#endregion
                eButton = eDiv.querySelectorAll(`#UPDATE_PREST${index}`)[0];
                //#region Ts
                eButton.addEventListener('click', function (): void {
                  const modelFact: any = {
                    Action: parameter,
                    Value: value,
                    IdDonnee: option,
                    Display: display
                  };
                  service.sendItem(key, modelFact);
                });
              }

              //#endregion
              break;
            //#endregion

            //#region ANG_MODEFACT
            case 'ANG_MODEFACT':
            case 'ANG_MODEFACTRAPID':
              //#region HTML
              const icon: string = parameter == 'ANG_MODEFACTRAPID' ? 'fa fa-forward' : 'fas fa-money-bill';
              if (display === '') {
                eDiv.innerHTML = `<i id="${parameter}${index}" class="${icon} color-icon q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="${parameter}${index}" class="${icon} color-icon q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll(`#${parameter}${index}`)[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                const modelFact: any = {
                  Action: parameter,
                  Value: value,
                  IdDonnee: option,
                  Display: display
                };
                service.sendItem(key, modelFact);
              });
              //#endregion
              break;
            //#endregion

            //#region ANG_EXPORT_EDOF
            case 'ANG_EDOF_ON':
              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ANG_EDOF_ON${value}" class="fas fa-circle q-c-success q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ANG_EDOF_ON${value}" class="fas fa-circle q-c-success q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll(`#ANG_EDOF_ON${value}`)[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                const model: any = {
                  Action: parameter,
                  Value: value,
                  TypeSession: option,
                  Display: display
                };
                service.sendItem(key, model);
              });
              //#endregion
              break;
            case 'ANG_EDOF_OFF':
              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ANG_EDOF_OFF${value}" class="fas fa-circle q-c-danger q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ANG_EDOF_OFF${value}" class="fas fa-circle q-c-danger q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll(`#ANG_EDOF_OFF${value}`)[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                const model: any = {
                  Action: parameter,
                  Value: value,
                  TypeSession: option,
                  Display: display
                };
                service.sendItem(key, model);
              });
              //#endregion
              break;
            //#endregion

            //#region BTN_CHECK
            case 'BTN_CHECK':
              //#region HTML
              switch (option) {
                case 'true':
                  if (display === '') {
                    eDiv.innerHTML = `<i id="BTN_CHECK${index}" class="far fa-check-square q-c-success q-pointer" placement="right"></i>`;
                  } else {
                    eDiv.innerHTML = `<i id="BTN_CHECK${index}" class="far fa-check-square q-c-success q-pointer" placement="right" title="${display}"></i>`;
                  }
                  break;
                default:
                  if (display === '') {
                    eDiv.innerHTML = `<i id="BTN_CHECK${index}" class="far fa-square color-icon q-pointer" placement="right"></i>`;
                  } else {
                    eDiv.innerHTML = `<i id="BTN_CHECK${index}" class="far fa-square color-icon q-pointer" placement="right" title="${display}"></i>`;
                  }
                  break;
              }
              //#endregion
              eButton = eDiv.querySelectorAll(`#BTN_CHECK${index}`)[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                const modelFact: any = {
                  Action: parameter,
                  IdDonnee: value,
                  // Ici value = option car 2 possibilité : 'true' ou 'false'
                  Value: option,
                  Display: display
                };
                service.sendItem(key, modelFact);
              });

              //#endregion
              break;
            //#endregion

            //#region ANG_MODALE
            case 'ANG_MODALE':
              //#region HTML
              if (display === '') {
                eDiv.innerHTML = `<i id="ANG_MODALE${index}" class="fas fa-edit color-icon q-pointer" placement="right"></i>`;
              } else {
                eDiv.innerHTML = `<i id="ANG_MODALE${index}" class="fas fa-edit color-icon q-pointer" placement="right" title="${display}"></i>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll(`#ANG_MODALE${index}`)[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                const modelModale: any = {
                  Action: parameter,
                  Value: value,
                };
                service.sendItem(key, modelModale);
              });
              //#endregion
              break;
            //#endregion

            default:
              break;
          }
          break;
        //#endregion
        //#region Bouton avec Texte
        case 'BUTTONANDTEXT':
          //#region affectation valeurs des variables
          display = paramArray[2];
          value = paramArray[4];
          idBo = paramArray[5];
          //////idDonnee = paramArray[5];
          //#endregion

          switch (parameter) {
            //#region ANG_FACT_COMM
            case 'ANG_FACT_COMM':
              //#region HTML
              if (!display || display === '') {
                eDiv.innerHTML = `<div class="h-100 row no-gutters align-items-center pl-1">` +
                  `<i id="ANG_FACT_COMM${index}" class="fas fa-edit q-c-main pr-2 q-pointer"></i>` +
                  `<div class="btnTxtEllipsis">${value}</div>` +
                  `</div>`;
              } else {
                eDiv.innerHTML = `<div class="h-100 row no-gutters align-items-center pl-1">` +
                  `<i id="ANG_FACT_COMM${index}" class="fas fa-edit q-c-main pr-2 q-pointer" title="${display}"></i>` +
                  `<div class="btnTxtEllipsis">${value}</div>` +
                  `</div>`;
              }
              //#endregion
              eButton = eDiv.querySelectorAll(`#ANG_FACT_COMM${index}`)[0];
              //#region Ts
              eButton.addEventListener('click', function (): void {
                const modelFactComm: any = {
                  Value: value,
                  Action: parameter,
                  Colonne: params.colDef.field,
                  Title: params.colDef.headerName,
                  IdDonnee: idBo
                };
                service.sendItem(key, modelFactComm);
              });
              //#endregion
              break;
            //#endregion
            default:
              break;
          }
          break;
        //#endregion
        //#region font
        case 'FONT':
          //#region affectation valeurs des variables
          display = paramArray[2];
          //#endregion
          switch (parameter) {
            //#region CIRCLE_ORANGE
            case 'CIRCLE_ORANGE':
              if (display === '') {
                eDiv.innerHTML = `<i id="CIRCLE_ORANGE" class="fas fa-circle q-c-warning"></i>`;
              } else {
                eDiv.innerHTML = `<i id="CIRCLE_ORANGE" class="fas fa-circle q-c-warning" title = "${display}" > </i>`;
              }
              break;
            //#endregion

            //#region CIRCLE_GREEN
            case 'CIRCLE_GREEN':
              if (display === '') {
                eDiv.innerHTML = `<i id="CIRCLE_GREEN" class="fas fa-circle q-c-success"></i>`;
              } else {
                eDiv.innerHTML = `<i id="CIRCLE_GREEN" class="fas fa-circle q-c-success" title = "${display}" > </i>`;
              }
              break;
            //#endregion

            //#region CIRCLE_RED
            case 'CIRCLE_RED':
              if (display === '') {
                eDiv.innerHTML = `<i class="fas fa-circle q-c-danger"></i>`;
              } else {
                eDiv.innerHTML = `<i class="fas fa-circle q-c-danger" title = "${display}" > </i>`;
              }
              break;
            //#endregion

            //#region CIRCLE_ORANGE_STOP
            case 'CIRCLE_ORANGE_STOP':
              if (display === '') {
                eDiv.innerHTML = `<i class="fas fa-stop-circle q-c-warning"></i>`;
              } else {
                eDiv.innerHTML = `<i class="fas fa-stop-circle q-c-warning" title = "${display}" > </i>`;
              }
              break;
            //#endregion


            //#region CIRCLE_RED_DOT
            case 'CIRCLE_RED_DOT':
              if (display === '') {
                eDiv.innerHTML = `<i class="fas fa-dot-circle q-c-danger"></i>`;
              } else {
                eDiv.innerHTML = `<i class="fas fa-dot-circle q-c-danger" title = "${display}" > </i>`;
              }
              break;
            //#endregion

            //#region DEGRADED_FIRE
            case 'DEGRADED_FIRE':
              if (display === '') {
                eDiv.innerHTML = `<i class="fas fa-fire q-fire-icon"></i>`;
              } else {
                eDiv.innerHTML = `<i class="fas fa-fire q-fire-icon" title = "${display}" > </i>`;
              }
              break;
            //#endregion

            //#region EDIT
            case 'EDIT':
              if (display === '') {
                eDiv.innerHTML = `<i class="fas fa-edit q-c-main q-pointer"></i>`;
              } else {
                eDiv.innerHTML = `<i class="fas fa-edit q-c-main q-pointer" title = "${display}" > </i>`;
              }
              break;
            //#endregion
            default:
              if (parameter !== '') {
                if (display === '') {
                  eDiv.innerHTML = `<i class="${parameter}"></i>`;
                } else {
                  eDiv.innerHTML = `<i class="${parameter}" title = "${display}" > </i>`;
                }
              }
              break;
          }
          break;
        //#endregion
        //#region combobox
        case 'COMBOBOX':
          //#region déclaration/affectation valeurs des variables
          option = paramArray[3];

          const listSelect: Array<{ id: string, value: string }> = JSON.parse(paramArray[2]).length < 1 ? [{ id: '0', value: '--------' }] : JSON.parse(paramArray[2]);
          if (listSelect[0].id !== '0') {
            listSelect.unshift({ id: '0', value: '--------' });
          }
          //#endregion
          eDiv.classList.add('h-100');
          //#region HTML
          let balisesHtmlOptions: string = '';

          for (let i: number = 0; i < listSelect.length; i++) {
            balisesHtmlOptions += `<option id="ANG_COMBOBOX_OPT_${i}" ${parameter === listSelect[i].id.toString() ? 'selected' : ''} value="${listSelect[i].id}">${listSelect[i].value}</option>`;
          }
          eDiv.innerHTML = `<select id="ANG_COMBOBOX${index}" class="w-100 q-main-grid-select">` +
            balisesHtmlOptions +
            `</select>`;
          //#endregion
          eButton = eDiv.querySelectorAll(`#ANG_COMBOBOX${index}`)[0];
          //#region Ts
          eButton.addEventListener('change', function (e: any): void {
            for (let i: number = 0; i < eButton.children.length; i++) {
              eButton.children[i].select = eButton.children[i].value === e.target.value;
            }

            const modelCombo: any = {
              Value: e.target.value,
              Action: 'COMBOBOX',
              IdDonnee: option,
              ColumnName: paramArray[4]
            };

            service.sendItem(key, modelCombo);
          });
          //#endregion
          break;
        //#endregion

        //#region checkbox
        case 'CHECKBOX':
          // HTML
          value = paramArray[4];
          if (display === '') {
            eDiv.innerHTML = ` <input id="ANG_CHECKBOX${index}" type="checkbox" ${value === 'true' ? 'checked' : ''}>`;
          }
          eButton = eDiv.querySelectorAll(`#ANG_CHECKBOX${index}`)[0];
          // checkboxclick event
          eButton.addEventListener('click', function (e: any): void {
            const it: GridParamGeneric = new GridParamGeneric();
            it.Val1 = paramArray[1];
            it.Val2 = paramArray[2];
            it.Val3 = paramArray[3];
            it.Val4 = '';
            it.Val5 = '';
            it.Selected = e.target.checked;
            it.Action = 'CHECKBOX';
            service.sendItem(key, it);
            //service.sendItem(key,{
            //  Val1: paramArray[1],
            //  Val2: paramArray[2],
            //  Val3: paramArray[3],
            //  Val4: '',
            //  Val5: '',
            //  Selected: e.target.checked
            //});
          });

          break;
        //#endregion

        //#region boutons radio
        //exemple d'utilisation dans la page suivi des présences des plannings formation : list-reservations
        // dans la grid: ListeStagiairesParReservation
        //dans le fichier xml:
        //fieldselect  doit faire référence à une colonne dont la valeur est 1 si l'on souhaite que le bouton radio soit coché.
        case 'RADIO':
          const rowIdent: string = params.api.getModel().getRow(params.rowIndex).id;
          display = paramArray[2];
          option = paramArray[3];
          value = paramArray[4];
          idBo = paramArray[5];
          idRelation = paramArray[6];
          idDonneePere = paramArray[7];
          idBOPere = paramArray[8];
          isShow = paramArray[9];
          // HTML
          eDiv.classList.add('q-check', 'radio');
          eDiv.innerHTML = ` <input name="ANG_RADIO${rowIdent}${identUnique}" id="ANG_RADIO${rowIdent}${idRelation}${identUnique}" type="radio" ${value && value != '0' ? 'checked' : ''} />`;
          eDiv.innerHTML += `<label for="ANG_RADIO${rowIdent}${idRelation}${identUnique}"><span></span>`;
          if (option) {
            switch (option) {
              //#region spécifique bouton signature
              // pour le cas particulier des boutons signatures (ou plus globalement des boutons radio sur les REL_BO_CONTACT_BO_RESERV_XXX
              //dans le fichier xml:
              //idDonneePere doit être égal à l'ident du stagiaire
              //idRelation doit correspondre à la relation : REL_BO_CONTACT_BO_RESERV_P, REL_BO_CONTACT_BO_RESERV_PREINS, REL_BO_CONTACT_BO_RESERV_A, REL_BO_CONTACT_BO_RESERV_I, ou éventuellement REL_BO_CONTACT_BO_STAGE
              //type == 'RADIO'
              //option == 'SIGN_BUTTON'
              //parameter == fiSigLIF du tPALienInfo
              case 'SIGN_BUTTON':
                if (parameter) {
                  eDiv.innerHTML += `<button class="q-btn q-main"
                data-toggle="popover"
                data-placement= "auto"
                data-container = "body"
                id="customgridRadio${rowIdent}${identUnique}${idRelation}"
                style="height: 23px;min-height: 10px;min-width: 10px;width: auto;padding-top: 0;">
                  <i class="fas fa-signature"></i>
                </button>`;
                }
                break;
              //#endregion
              default:
                eDiv.innerHTML += `${option}`;
                break;
            }
          }
          eDiv.innerHTML += `</label>`;
          eButton = eDiv.querySelectorAll(`#ANG_RADIO${rowIdent}${idRelation}${identUnique}`)[0];
          // checkboxclick event
          eButton.addEventListener('click', function (e: any): void {
            const it: GridParamGeneric = new GridParamGeneric();
            it.Val1 = paramArray[1];
            it.Val2 = paramArray[2];
            it.Val3 = paramArray[3];
            it.Val4 = idDonneePere;
            it.Val5 = idRelation;
            it.Selected = e.target.checked;
            it.Action = type;

            service.sendItem(key, it);
          });

          //#region spécifique bouton signature
          if (option == 'SIGN_BUTTON' && parameter) {
            let signPopover = eDiv.querySelectorAll(`#customgridRadio${rowIdent}${identUnique}${idRelation}`)[0];

            ($(signPopover) as any).popover({
              html: true,
              content: `
              <div class="h-100 w-100" id="popoverCustomgridRadio${rowIdent}${identUnique}${idRelation}">
                  <div style="width: 150px;
                              height: 150px;
                              margin: auto;
                              border-radius: 5px;
                              border: 1px solid var(--c-main);
                              justify-content: center;
                              display: flex;
                              align-items: center;">
                    <img id="imgCustomgridRadio${rowIdent}${identUnique}${idRelation}" src="${this.indParam.getConfigKey('IMAGESFOLDER')}Signature\\${this.indParam.ClientDB}\\${parameter}" class="h-100 w-100"/>
                  </div>
                  <div class="row m-1">
                    <button id="deleteBtnCustomgridRadio${rowIdent}${identUnique}${idRelation}" class="q-btn q-danger m-0"><i class="fas fa-trash mr-2"></i>Supprimer la signature</button>
                  </div>
              </div>`
            });

            $(signPopover).on('inserted.bs.popover', () => {
              let btnElement = $(`#deleteBtnCustomgridRadio${rowIdent}${identUnique}${idRelation}`)[0];
              if (!btnElement?.onclick) {
                btnElement.addEventListener('click', () => {
                  if (!idDonneePere || !value || !idRelation || idDonneePere == '0' || value == '0' || idRelation == '0') {
                    return;
                  }
                  pHttpService.getHttp<EventsModel>(`${indParam.AppParams.apiUrl}api/signature/DELETE_SIGNATURE/${idDonneePere}|${value}|${idRelation}`).subscribe((data: EventsModel) => {
                    if (!data.HasError) {
                      ($(signPopover) as any).popover("hide");
                      signPopover.remove();
                    }
                  });
                });
              }

              let imgElement = $(`img#imgCustomgridRadio${rowIdent}${identUnique}${idRelation}`)[0];
              if (!(imgElement as any)?.onerror && !(imgElement as any)?.error) {
                imgElement.addEventListener('error', () => {
                  $(imgElement).after(`<i class="fas fa-signature fa-3x q-c-main"></i>`);
                  imgElement.remove();
                });
              }
            });
            $(signPopover).on('hidden.bs.popover', () => { $(document).unbind('click', hide); });
            let hide = (e: any) => {
              if ($(e.target).closest(`#customgridRadio${rowIdent}${identUnique}${idRelation}`).length != 0 || $(e.target).closest(`#popoverCustomgridRadio${rowIdent}${identUnique}${idRelation}`).length != 0) return;
              ($(signPopover) as any).popover("hide");
            };

            signPopover.addEventListener('click', (e: any) => {
              ($(e.currentTarget) as any).popover();
              $(document).click(hide);
            });
          }
          //#endregion
          break;
        //#endregion

        //#region ischeckbox
        case 'ISCHECKBOX':
          //#region affectation valeurs des variables
          //////idDonnee = paramArray[5];
          value = paramArray[4];
          idBo = paramArray[5];
          //#endregion

          //#region HTML
          if (display === '') {
            eDiv.innerHTML = ` <input id="ANG_ISCHECKBOX${index}" type="checkbox" ${value === 'true' ? 'checked' : ''}>`;
          }
          //#endregion
          eButton = eDiv.querySelectorAll(`#ANG_ISCHECKBOX${index}`)[0];
          //#region Ts
          eButton.addEventListener('click', function (e: any): void {

            const modelprest: any = {
              Value: e.target.checked.toString(),
              Action: parameter,
              //////IdDonnee: idDonnee
              IdDonnee: idBo
            };
            service.sendItem(key, modelprest);
          });
          //#endregion
          break;
        //#endregion

        //#region textarea
        case 'TEXTAREA':
          display = paramArray[2];
          eDiv.innerHTML = `<textarea style="${parameter}" disabled> ${display}</textarea>`;
          break;
        //#endregion
        case 'WEBLINK':
          display = paramArray[2] != '' ? paramArray[2] : parameter;
          eDiv.innerHTML = `<a href="${parameter}" target="_blank">${display}</a>`;
          break;
        default:
          //eDiv.innerHTML = `<span class="my-css-class"><button class="btn-simple">Push Me</button></span>`;
          //eButton = eDiv.querySelectorAll('.btn-simple')[0];

          //eButton.addEventListener('click', function (): void {
          //});
          break;
      }
      return eDiv;
    };


  }
  // #endregion

  public DonwloadFileFromCustomgrid(e: any, value: string, noDocx: boolean = true, mode: string = 'GETINFODOWNLOAD') {
    if (e.target?.classList.contains('fa-spin')) {
      this.toastService.showWarningToast('Un téléchargement de fichier est déjà en cours.');
      return;
    }
    e.target.classList.remove('fa-file-upload');
    e.target.classList.add('fa-spin');
    e.target.classList.add('fa-pulse');
    e.target.classList.add('fa-spinner');

    const customgridModel: CustomgridModel = new CustomgridModel();
    customgridModel.FileModel.Ident = value;
    customgridModel.cgParameters.Mode = mode;
    this.httpService.postHttp<CustomgridModel>(`${this.indParam.AppParams.apiUrl}api/customgrid`, customgridModel).subscribe((data: CustomgridModel) => {
      customgridModel.FileModel = data.FileModel;
      customgridModel.FileModel.DownloadMode = 'FROMGRID';

      this.httpService.download(`${this.indParam.AppParams.apiUrl}api/Download`, customgridModel.FileModel).subscribe((response: any) => {
        if (response) {
          let extension: string | undefined = customgridModel.FileModel.Extension !== '' ? customgridModel.FileModel.Extension : customgridModel.FileModel.Name.split('.').pop();
          let fileType: string = '';
          switch (extension) {
            case '.zip': fileType = 'application/zip'; break;
            case '.pdf': fileType = 'application/pdf'; break;
            case '.jpg': fileType = 'image/jpg'; break;
            case '.jpeg': fileType = 'image/jpeg'; break;
            case '.png': fileType = 'image/png'; break;
            case '.gif': fileType = 'image/gif'; break;
            case '.xml': fileType = 'application/xml'; break;
            case '.txt': fileType = 'text/plain'; break;
            case '.doc': fileType = 'application/vnd.ms-word'; break;
            case '.docx': fileType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'; break;
            case '.xls': fileType = 'application/vnd.ms-excel'; break;
            case '.xlsx': fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'; break;
            case '.bmp': fileType = 'image/bmp'; break;
            case '.wav': fileType = 'audio/wav'; break;
            case '.ppt': fileType = 'application/vnd.ms-powerpoint'; break;
            case '.pptx': fileType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation'; break;
            case '.dwg': fileType = 'image/vnd.dwg'; break;
          }

          if (extension === '.docx' && noDocx) {
            extension = '.pdf';
            fileType = 'application/pdf';
          }
          const blob: Blob = new Blob([(response)], {
            type: fileType,
          });

          if (blob.size > 0) {
            //fileSaver.saveAs(blob, `${value}${customgridModel.FileModel.Extension}`);
            fileSaver.saveAs(blob, `${value}${extension}`);
          }

        } else {
          this.toastService.showWarningToast(`Le fichier ${customgridModel.FileModel.Name} n'existe pas sur le serveur`);
        }
        setTimeout(() => {
          e.target.classList.add('fa-file-upload');
          e.target.classList.remove('fa-spin');
          e.target.classList.remove('fa-pulse');
          e.target.classList.remove('fa-spinner');
        }, 500)
      });

    });
  }

}
